export const MEETING_ROOM_SETTINGS_API = {
  BASE: '/v1/hub/company/meeting-room/settings',
} as const
